import React from "react";

function ShareNewExercisePage() {
  return (
    <div>
      <h1>Share new exercise</h1>
    </div>
  );
}

export default ShareNewExercisePage;
